import apiClient from "./apiClient";

//============== Get Live Classes by UserId=============

export const getLiveClasses = async (userId) => {
 return await apiClient.get(`/LiveClasses/GetLiveClasses?userId=${userId}`);
};

